
import sys from '@/common/js/sys'
import InformationRouter from './router/InformationRouter.js'
import RotationChartRouter from './router/RotationChartRouter.js'
let oeduRouter = [...InformationRouter,...RotationChartRouter];
oeduRouter.push({
    path: '/',
    component: resolve => require(['./Index.vue'], resolve),
    title: sys.config.systemName
});

export default oeduRouter;



// WEBPACK FOOTER //
// ./src/content/portalSite/PortalSiteRouter.js